import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { SharedService } from './shared/services/shared.service';
import { SidebarModule } from './shared/index';
import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import {
  AuthGuard,
  CommonCloudStudioModule,
  ENVIRONMENT,
  TOASTER_CONFIG,
  APP_TOKEN,
  ReportsModule,
  LoginModule,
  DashboardModule,
  TopNavComponent,
  ModalFooter,
  ModalContent,
  ModalHeader,
  Modal,
  DashboardComponent,
  PlansModule,
  AppService,
  DummyAuthService,
  PUSH_NOTIFICATION_CONFIG
} from 'common-cloudstudio';
import { CommonGearModule } from 'common-gear';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DevicesComponent } from './devices/devices.component';
import { ModalCameraComponent } from './modal-camera/modal-camera.component';
import { HistoricalDataComponent } from './historical-data//historical-data.component';
import { TanksComponent } from './tanks/tanks.component';
import { DatePipe } from "@angular/common";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedDashboardComponent } from './shared-dashboard/shared-dashboard.component';
import { ModalShareComponent } from './modal-share/modal-share.component';
import { SharedPlansComponent } from './shared-plans/shared-plans.component';

import { CustomerModule } from './customer-modules/customer/customer.module';
import { AssetTrackingModule } from './asset-tracking/asset-tracking.module';
import { ModalSnapshotsComponent } from './modal-snapshots/modal-snapshots.component';
import { DeviceMapComponent } from './device-map/device-map.component';
import { MapService } from '../app/shared/services/map.service';
import { DashboardsComponent } from './dashboards/dashboards.component';
import { ModalChangeValueEndpointsComponent } from './modal-change-value-endpoints/modal-change-value-endpoints.component';
import { PlansComponent } from './plans/plans.component';
import { IncidentsModule } from './incidents/incidents.module';
import { AuthService } from '@auth0/auth0-angular';
import { MapsModule } from './maps/map.module';
import { GoogleMapsModule } from '@angular/google-maps';

declare var environment;

export function toasterConfig() {
  return new ToasterConfig({
    positionClass: 'toast-top-right',
    showCloseButton: true
  });
}
export function environmentFactory(): any {
  return environment;
}

export function get_settings(appService: AppService) {
  return async () => appService?.setStartingSettings();
}

@NgModule({
  declarations: [
    AppComponent,
    DevicesComponent,
    ModalCameraComponent,
    HistoricalDataComponent,
    TanksComponent,
    SharedDashboardComponent,
    ModalShareComponent,
    SharedPlansComponent,
    ModalSnapshotsComponent,
    DeviceMapComponent,
    DashboardsComponent,
    ModalChangeValueEndpointsComponent,
    PlansComponent
  ],
  exports: [],
  imports: [
    GoogleMapsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    ToasterModule,
    CommonCloudStudioModule.forRoot(),
    CommonGearModule.forRoot(),
    SidebarModule,
    routes,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    LoginModule,
    ReportsModule,
    DashboardModule,
    CollapseModule.forRoot(),
    CustomerModule,
    AssetTrackingModule,
    IncidentsModule,
    PlansModule,
    MapsModule
  ],
  providers: [
    AuthGuard,
    SharedService,
    ToasterService,
    DatePipe,
    MapService,
    AppService,
    { provide: TOASTER_CONFIG, useFactory: toasterConfig },
    { provide: ENVIRONMENT, useFactory: environmentFactory },
    { provide: APP_TOKEN, useValue: environment.appToken },
    { provide: PUSH_NOTIFICATION_CONFIG, useValue: environment.firebase || null },
    { provide: APP_INITIALIZER, useFactory: get_settings, deps: [AppService], multi: true },
    environment.useOfflineMode ? { provide: AuthService, useClass: DummyAuthService } : []
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    TopNavComponent,
    Modal,
    ModalHeader,
    ModalContent,
    ModalFooter,
  ]
})
export class AppModule {}
